import styled from "styled-components";
import { Button, Type } from "discover.medical.react-component-library";

export const DrugInteractionsResultsItemContainer = styled.div`
  position: relative;
  margin-bottom: ${({ theme }) => theme.space.xl};
  cursor: ${({ $isClickable }) => ($isClickable ? "pointer" : "default")};

  /* Hack but this is needed so Popper doesn't cause onMouseLeave when appearing */
  [x-placement] {
    pointer-events: none;
  }

  & > *:not(:first-child) {
    margin-top: ${({ theme }) => theme.space.md};
  }
`;

export const SeeDetailsButton = styled(Button)`
  font-size: ${({ theme }) => theme.font.size.md};
`;

export const SeverityIndexLabel = styled(Type)`
  color: ${({ theme }) => theme.colors.gray700};
`;
